// eslint-disable-next-line import/no-extraneous-dependencies
import { Module } from 'vuex';

export enum AIMessageType {
    me = 0,
    other = 1,
    introducation = 2,
}

export enum AIMessageStatus {
    done = 0, // 默认
    loading = 1,
    progressing = 2,
    error = 3,
}

type BotId = string;
export interface AIMessage {
    botId: string;
    messageId: string;
    messageType: AIMessageType;
    content: string;
    messageStatus: AIMessageStatus;
}

export interface AIChat {
    botId?: string;
    messages: AIMessage[];
}

export type AIConversationOriginalType = Partial<Record<BotId, AIChat>>;

export interface AIConversationModuleType {
    conversations?: AIConversationOriginalType;
    loadingMessages?: AIMessage[];
}

const defaultState: AIConversationModuleType = {
    conversations: {},
    loadingMessages: [],
};

export const conversationModule: Module<AIConversationModuleType, any> = {
    namespaced: true,
    state: defaultState,
    mutations: {
        storeMessage(state, payload: { botId?: BotId; message?: string; messageId?: string; type?: AIMessageType; messageStatus?: AIMessageStatus }) {
            if (!payload.botId || !payload?.messageId || payload.type === undefined) {
                return;
            }
            const { botId, messageId, messageStatus, type, message } = payload;
            if (messageStatus && messageStatus === AIMessageStatus.loading) {
                const loadingMessage = state.loadingMessages?.find(message => message.messageId === messageId);
                if (!loadingMessage) {
                    // state.loadingMessages?.forEach(item => {
                    //     const botIdLoading = item?.botId;
                    //     const messageIdLoading = item?.messageId;
                    //     this.deleteMessage(state, { botIdLoading, messageIdLoading });
                    // });
                    state.loadingMessages?.push({
                        botId,
                        messageId,
                        messageType: type,
                        content: '',
                        messageStatus: AIMessageStatus.loading,
                    });
                }
            }
            const aiChat = state?.conversations?.[payload.botId] || { botId: payload.botId, messages: [] };

            if (type === AIMessageType.introducation) {
                const targetMessage = aiChat.messages.find(amessage => amessage.content === message);
                if (targetMessage) return;
            }

            if (messageStatus === AIMessageStatus.loading) {
                const targetMessage = aiChat.messages.find(amessage => amessage.messageId === messageId);
                if (targetMessage) return;
            }

            const messageObj = {
                botId,
                messageType: payload.type,
                messageId,
                content: message || '',
                messageStatus: messageStatus || AIMessageStatus.done,
            };
            aiChat.messages.push(messageObj);
            state.conversations = { ...state.conversations, ...{ [payload.botId]: aiChat } };
            // to-do 可以添加最多缓存多少条的控制
            console.log('social-ai', 'storeMessage', state.conversations);
        },

        updateMessage(
            state,
            payload: { botId?: BotId; message?: string; messageId?: string; type?: AIMessageType; messageStatus?: AIMessageStatus }
        ) {
            if (!payload.botId || !payload.message || !payload?.messageId || payload.type === undefined) {
                return;
            }
            const aiChat = state?.conversations?.[payload.botId] || { botId: payload.botId, messages: [] };
            const { messageId, messageStatus } = payload;
            const targetMessage = aiChat.messages.find(message => message.messageId === messageId);
            console.log('social-ai', 'updateMessage', targetMessage, payload.message);
            if (!targetMessage) {
                return;
            }
            const modifiedContent = `${targetMessage?.content}${payload.message}`;
            // if (modifiedContent.length > 1000) return;
            targetMessage.content = modifiedContent;
            targetMessage.messageStatus = messageStatus || targetMessage.messageStatus;
            state.conversations = { ...state.conversations, ...{ [payload.botId]: aiChat } };

            // to-do 可以添加最多缓存多少条的控制
        },
        deleteMessage(state, payload: { botId?: BotId; messageId?: string }) {
            if (!payload.botId || !payload?.messageId) {
                return;
            }
            const aiChat = state?.conversations?.[payload.botId] || { botId: payload.botId, messages: [] };
            const { messageId } = payload;
            const targetMessage = aiChat.messages.find(message => message.messageId === messageId);
            console.log('social-ai', 'deleteMessage', targetMessage);
            if (!targetMessage) {
                console.log('social-ai', 'deleteMessage', 'no target message', targetMessage);
                return;
            }

            const indexToDelete = aiChat.messages.indexOf(targetMessage);
            if (indexToDelete > -1) {
                aiChat.messages.splice(indexToDelete, 1);
            }
            state.conversations = { ...state.conversations, ...{ [payload.botId]: aiChat } };
        },
    },
    actions: {
        storeMessage({ commit }, payload) {
            commit('storeMessage', payload);
        },
        updateMessage({ commit, state }, payload) {
            if (!payload.botId || !payload.message || !payload?.messageId || payload.type === undefined) {
                return;
            }
            const aiChat = state?.conversations?.[payload.botId];
            const { messageId } = payload;
            const targetMessage = aiChat?.messages.find(message => message.messageId === messageId);
            if (!targetMessage) {
                commit('storeMessage', { ...payload, message: '' });
            }
            commit('updateMessage', payload);
        },
    },
};
